export const APP_NAME = "Applyform";
export const PERSIST_STORE_NAME = "admin";
export const REDIRECT_URL_KEY = "redirectUrl";
export const SCT_KEY = "SCT-ID";
